<template>
  	<div id="app" class="main">
  		  <keep-alive>
        	  <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
  	</div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style lang="less">
html,body{
    width: 100%;
    height: 100%;
    box-sizing:content-box;
}
.main{
	width: 100%;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue